<router-outlet>
  <ngx-spinner
    bdColor="rgb(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="square-jelly-box"
    [fullScreen]="true"
    ><p style="color: rgb(255, 255, 255)">Loading...</p></ngx-spinner
  >
</router-outlet>
